jQuery(document).ready(function($) {
	const classBase = 'm-archive-navigation';
	const $archive = $('.m-archive');
	const $postList = $('.m-posts-list-container .row');
	const type = $archive.data('type');
	const $navigationWrappers = $(`.${classBase}-wrapper`);
	const $previous = $(`.${classBase}--previous`);
	const $next = $(`.${classBase}--next`);
	const loaderHtml = `<div class="merchup-loader blockUI blockOverlay"></div>`;
	const taxonomyID = $archive.data('id');

	/**
	 *	Set Banner Height
	 */
	let $itemThumbnail = $('main .m-woocommerce-products-list .m-woocommerce-products-list-item .attachment-woocommerce_thumbnail');
	$('.m-woocommerce-products-list-item-banner').css('--merchup-category-banner-height', `${$itemThumbnail.height()}px`);
	$(window).resize(function(event) {
		let $itemThumbnail = $('main .m-woocommerce-products-list .m-woocommerce-products-list-item .attachment-woocommerce_thumbnail');
		$('.m-woocommerce-products-list-item-banner').css('--merchup-category-banner-height', `${$itemThumbnail.height()}px`);
	});

	/**
	 *	Load More
	 */
	$navigationWrappers.each(function(index, el) {
		const $this = $(el);
		const has_pagination = $this.find('a');
		if (!has_pagination.length) {
			return;
		}

		let url = has_pagination.attr('href');
		const pageNumber = url.replace(/\/\s*$/, "").split('/').pop();

		const buttonType = $this.data('type');
		const buttonText = merchupSettings.archive.navigation[buttonType];
		const buttonHtml = `
			<button class="u-button" type="button">
				${buttonText}
			</button>
		`;

		const $button = $this.html(buttonHtml);
		$button.click(function(event) {
			const value = $('.m-woocommerce-toolbar-product-search-field').val();
			let paged = $this.data('paged');
			if ( 'previous' == buttonType ) {
				paged = parseInt(paged) - 1;
				if (paged <= 0) {
					paged = 1;
				}
			}

			if ( 'next' == buttonType ) {
				paged = parseInt(paged) + 1;
			}

			$navigationWrappers.append(loaderHtml);
			$button.attr('disabled');

			$.ajax({
				url: merchupSettings.ajaxUrl,
				type: 'POST',
				data: {
					action: 'merchup_get_posts',
					paged: paged,
					type: type,
					search: value,
					taxonomy: taxonomyID,
				},
			})
			.done(function(response) {
				if (response.success) {
					const data = response.data;
					$postList.append(data.results);

					$this.data('paged', paged);

					if (!data.has_more) {
						$button.slideUp();
					}
				} else {
					$button.slideUp();
				}

				url = url.replace(pageNumber, paged);

				history.replaceState({}, "", url);
			})
			.always(function() {
				const $loader = $('.m-archive .merchup-loader');
				$loader.fadeOut(300, function() {
					$button.removeAttr('disabled');
				});
			});

			event.preventDefault();
		});


	});

	$navigationWrappers.each(function(index, el) {
		const $this = $(el);
		var urlCurrent = window.location.pathname;
		var pageCurrent = urlCurrent.replace(/\/\s*$/, "").split('/').pop();

		if ($postList.hasClass("load-ajax")) {
			$navigationWrappers.append(loaderHtml);
			$navigationWrappers.addClass("loading-box")
			const value = $('.m-woocommerce-toolbar-product-search-field').val();
			$postList.html('');
			$.ajax({
				url: merchupSettings.ajaxUrl,
				type: 'POST',
				data: {
					action: 'merchup_get_posts',
					paged: pageCurrent,
					type: type,
					search: value,
					taxonomy: taxonomyID,
					getAll: true
				},
			})
			.done(function(response) {
				if (response.success) {
					const data = response.data;

					$postList.append(data.results);
					$this.data('paged', pageCurrent);

					// if (!data.has_more) {
					// 	$button.slideUp();
					// }
				} else {
					// $button.slideUp();
				}

				// url = url.replace(pageNumber, paged);

				// history.replaceState({}, "", url);
			})
			.always(function() {
				const $loader = $('.m-archive .merchup-loader');
				$navigationWrappers.removeClass("loading-box")
				$loader.fadeOut(300);
			});
			
		}
	})

	/**
	 *	Search
	 */
	const $searchForm = $('.m-woocommerce-toolbar-product-search');
	$searchForm.submit(function(event) {
		const value = $('.m-woocommerce-toolbar-product-search-field').val();
		const currentUrl = window.location.href;

		$postList.append(loaderHtml);

		$.ajax({
			url: merchupSettings.ajaxUrl,
			type: 'POST',
			data: {
				action: 'merchup_get_posts',
				type: type,
				search: value,
				currentUrl: currentUrl,
				taxonomy: taxonomyID,
			},
		})
		.done(function(response) {
			if (response.success) {
				const data = response.data;

				if (data.results) {
					$postList.html(data.results);
				} else if (data.no_results) {
					$('.m-posts-list-loop').html(data.no_results);
				}

				history.pushState({}, "", data.search_url);
			}
		})
		.always(function() {
			const $loader = $('.m-archive .merchup-loader');
			$loader.fadeOut(300);
		});

		event.preventDefault();
	});
});

